import React from 'react';

import Breadcumb from './Breadcumb';
import Content from './Content';
import HotelOptions from './HotelOptions';
import ContactGallery from './ContactGallery';

function Main() {
  return (
    <>
      <Breadcumb />
      <Content />
      <HotelOptions />
      <ContactGallery />
    </>
  );
}

export default Main;
